export const AutomationModuleTypes = {
    CHAT: "CHAT",
    CONTACT: "CONTACT",
    EMAIL: "EMAIL",
    TASK: "TASK",
    META_LEAD: "META_LEAD",
    AGENT: "AGENT",
    INVOICE: "INVOICE",
    WHATSAPP: "WHATSAPP",
    RESERVATION: "RESERVATION",
    CHATBOT: "CHATBOT",
    TICKET: "TICKET",
    FORM: "FORM",
    VOICE_AGENT: "VOICE_AGENT",
    WEBPHONE: "WEBPHONE",
    CHANNEL: "CHANNEL",
    YOUTUBE: "YOUTUBE",
    GOOGLE_BUSINESS: "GOOGLE_BUSINESS",
    GOOGLE_PLAY: "GOOGLE_PLAY",
    APP_STORE: "APP_STORE",
};
export const AutomationEventTypes = {
    FORM: {
        SUBMITTED: "form.submitted",
    },
    CHAT: {
        CREATED: "chat.created",
        CLOSED: "chat.closed",
    },
    CONTACT: {
        CREATED: "contact.created",
        UPDATED: "contact.updated",
        TAG_ADDED: "contact.tag-added",
        TAG_REMOVED: "contact.tag-removed",
        PROFILE_BUTTON_CLICKED: "contact.profile_button_clicked",
        CONTACT_PROPERTY_UPDATED: "contact.contact-property-updated",
        AD_VIEWED: "contact.ad_viewed",
    },
    EMAIL: {
        RECEIVED: "email.received",
    },
    TASK: {
        CREATED: "task.created",
        COMPLETED: "task.completed",
        UPDATED: "task.updated",
        ASSIGNEE_CHANGED: "task.assignee-changed",
        PRIORITY_CHANGED: "task.priority-changed",
        DUE_DATE_CHANGED: "task.due-date-changed",
        STAGE_CHANGED: "task.stage-changed",
        ARCHIVED: "task.archived",
        DELETED: "task.deleted",
        TAG_ADDED: "task.tag-added",
        TAG_REMOVED: "task.tag-removed",
        CHECKLIST_COMPLETED: "task.checklist-completed",
        REMINDER_ACTIVATED: "task.reminder-activated",
    },
    META_LEAD: {
        CREATED: "meta-lead.created",
    },
    AGENT: {
        CREATED: "agent.created",
    },
    INVOICE: {
        CREATED: "invoice.created",
    },
    WHATSAPP: {
        MESSAGE_RECEIVED: "whatsapp.message-received",
    },
    RESERVATION: {
        CREATED: "reservation.created",
    },
    CHATBOT: {
        MESSAGE_RECEIVED: "chatbot.message-received",
    },
    TABLE: {
        RECORD_CREATED: "table.record_created",
        RECORD_UPDATED: "table.record_updated",
        RECORD_DELETED: "table.record_deleted",
        RECORD_AUTOMATION_BUTTON_CLICKED: "table.record_automation_button_clicked",
    },
    MESSAGE: {
        MESSAGE_PICKED: "message.picked",
    },
    TICKET: {
        CREATED: "ticket.created",
        UPDATED: "ticket.updated",
        STATUS_CHANGED: "ticket.status-changed",
        ASSIGNEE_CHANGED: "ticket.assignee-changed",
        CLOSED: "ticket.closed",
    },
    CALENDAR: {
        EVENT_CREATED: "calendar.event_created",
        EVENT_UPDATED: "calendar.event_updated",
        EVENT_DELETED: "calendar.event_deleted",
        RESERVATION_CREATED: "calendar.reservation_created",
        RESERVATION_DATE_CHANGED: "calendar.reservation_date_changed",
        RESERVATION_DELETED: "calendar.reservation_deleted",
    },
    VOICE_AGENT: {
        CALL_STARTED: "voiceagent.call_started",
        CALL_ENDED: "voiceagent.call_ended",
        CALL_ANALYZED: "voiceagent.call_analyzed",
    },
    WEBPHONE: {
        CALL_EVENT: "webphone.call_event",
        CALL_ANSWERED: "webphone.call_answered",
        CALL_ENDED: "webphone.call_ended",
        CALL_RINGING: "webphone.call_ringing",
        INBOUND_CALL: "webphone.inbound_call",
        OUTBOUND_CALL: "webphone.outbound_call",
        DEVICE_STATE_CHANGED: "webphone.device_state_changed",
        DEVICE_RINGING: "webphone.device_ringing",
        DEVICE_IN_USE: "webphone.device_in_use",
        DEVICE_AVAILABLE: "webphone.device_available",
    },
    CHANNEL: {
        STATUS_CHANGED: "channel.status_changed",
        DISCONNECTED: "channel.disconnected",
    },
    YOUTUBE: {
        COMMENT_RECEIVED: "youtube.comment_received",
    },
    GOOGLE_BUSINESS: {
        REVIEW_RECEIVED: "google_business.review_received",
    },
    GOOGLE_PLAY: {
        REVIEW_RECEIVED: "google_play.review_received",
    },
    APP_STORE: {
        REVIEW_RECEIVED: "app_store.review_received",
    },
};
